import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject, Subscription } from "rxjs/Rx";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { debounceTime } from "rxjs/operator/debounceTime";
import { CommunityManagerService } from "../../../shared/services/user/community-manager.service";
import { FileUploadService } from "../../../shared/services/fileuploadservice";
import { ActivatedRoute } from "../../../../../node_modules/@angular/router";
import { User } from "../../../shared/user/user";
import { LoaderService } from "../../../shared/services/loader.service";
import { IMyDpOptions } from "mydatepicker";
import { CommunityService } from "../../../shared/services/community/community.service";
import { AuthService } from "../../../shared/services/auth.service";
import { BackendService } from "../../../shared/services/backend.service";
import * as firebase from "firebase/app";
import * as EmailValidator from "email-validator";

@Component({
  selector: "app-community-manager",
  templateUrl: "./community-manager.component.html",
  styleUrls: ["./community-manager.component.css"]
})
export class CommunityManagerComponent implements OnInit, OnDestroy {
  currentDate = new Date();

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: "yyyy-mm-dd",
    editableDateField: false,
    disableSince: {
      year: this.currentDate.getFullYear(),
      month: this.currentDate.getMonth() + 1,
      day: this.currentDate.getDate() + 1
    }
  };

  private _alert: Subject<string> = new Subject<string>();
  private alertSubscription: Subscription = new Subscription();
  private communityManagers$: Subscription = new Subscription();
  private uploadedAvatarURL$: Subscription = new Subscription();
  routeSubscription: Subscription = new Subscription();
  modalReference: NgbModalRef;
  communityManagers = [];
  communityId: string;
  community;
  page = 1;
  user: User;
  singleManager: any;
  communityMgrMirrored: any;
  confirmationMessage = "";
  confirmationTitle = "";
  successMessage = "";
  errorMessage = "";
  emailNotUniqueError = "";
  genders = ["Female", "Male"];
  tempDateOfBirth;
  query = "";
  validEmail: boolean;
  actionType = "";
  userId: string;
  authState: firebase.User | null;

  constructor(
    private authService: AuthService,
    private communityService: CommunityService,
    private modalService: NgbModal,
    private communityManagerService: CommunityManagerService,
    private uploadService: FileUploadService,
    private loaderService: LoaderService,
    private route: ActivatedRoute
  ) {
    this.user = new User();
    this.authState = this.authService.getAuthState();
    this.userId = BackendService.generateUserId(this.authState.email);
  }

  ngOnInit(): void {
    this.loaderService.startLoader();
    this.routeSubscription = this.route.params.subscribe(params => {
      this.communityId = params.communityId;
      this.communityService.getCommunityById(params.communityId).subscribe(data => (this.community = data));
      this.communityManagers$ = this.communityManagerService.list(this.communityId).subscribe(data => {
        this.communityManagers = data;
        this.loaderService.stopLoader();
      });
    });
  }

  ngOnDestroy(): void {
    this.closeModal();
    this.routeSubscription.unsubscribe();
    this.communityManagers$.unsubscribe();
    this.uploadedAvatarURL$.unsubscribe();
  }

  viewManager(modal, manager): void {
    this.singleManager = manager;
    if (this.singleManager.dateOfBirth.date) {
      this.tempDateOfBirth = this.singleManager.dateOfBirth.date;
    } else {
      this.tempDateOfBirth = this.singleManager.dateOfBirth;
      this.singleManager.dateOfBirth = { date: this.singleManager.dateOfBirth };
    }
    this.openModal(modal, "md");
  }

  createOrEditCommunityMgr(modal, user): void {
    if (user) {
      this.closeModal();
    }
    this.communityMgrMirrored = { ...new User(), ...user };
    this.openModal(modal, "md");
  }

  openImageUploader(): void {
    const element = document.getElementById("imageUploader") as HTMLElement;
    element.click();
  }

  uploadImage(event): void {
    this.loaderService.startLoader();
    const file = event.target.files[0];
    const imgURL = this.uploadService.upload("avatars", file);
    this.uploadedAvatarURL$ = imgURL.subscribe(data => {
      this.communityMgrMirrored.avatar = data;
      this.loaderService.stopLoader();
    });
  }

  confirmDelete(user: any, modal): void {
    const message = `Are you sure you want to delete ${user.firstName} ${user.lastName}?`;
    this.confirm("Delete Community Manager!", message, modal);
  }

  deleteCommunityMgr(): void {
    this.closeModal();
    this.showAlert(true, "Community manager deleted successfully.");
  }

  confirmAction(type, user: any, modal): void {
    this.user = user;
    this.actionType = type;
    const message = `Are you sure you want to ${type} ${user.firstName} ${user.lastName}"s account?`;
    this.confirm("Attention!", message, modal);
  }

  deactivateCommunityMgr(): void {
    this.communityManagerService
      .deactivate(this.communityId, this.singleManager.id);
    this.closeModal();
    this.showAlert(true, "Community manager deactivated successfully.");
  }

  activateCommunityMgr(): void {
    this.communityManagerService.activate(this.communityId, this.singleManager.id);
    this.closeModal();
    this.showAlert(true, "Community manager activated successfully.");
  }

  async saveCommunityMgr(): Promise<void> {
    this.loaderService.startLoader();
    this.communityMgrMirrored.communityName = this.community.name;
    this.communityMgrMirrored.dateOfBirth.date !== this.tempDateOfBirth
      ? (this.communityMgrMirrored.dateOfBirth = this.communityMgrMirrored.dateOfBirth.formatted)
      : (this.communityMgrMirrored.dateOfBirth = this.tempDateOfBirth);
    let result = await this.authService.authenticateNewUser(this.communityMgrMirrored.email);
    if (!result.state) {
      this.showAlert(result.state, result.message);
    } else {
      const userId = result.message;
      if (userId && !this.communityMgrMirrored.id) {
        this.communityMgrMirrored.id = userId;
        result = await this.communityManagerService.create(this.communityMgrMirrored, this.community);
      } else if (userId && this.communityMgrMirrored.id) {
        if (this.communityMgrMirrored["hasRoles"]) {
          delete this.communityMgrMirrored["hasRoles"];
        }

        if (this.communityMgrMirrored["isActiveManager"]) {
          delete this.communityMgrMirrored["isActiveManager"];
        }
        result = await this.communityManagerService.update(this.communityMgrMirrored, this.community);
      }
      this.showAlert(result.state, result.message);
    }
    this.loaderService.stopLoader();
    this.closeModal();
  }

  confirm(title, message, modal): void {
    this.confirmationTitle = title;
    this.confirmationMessage = message;
    this.closeModal();
    this.openModal(modal, "sm");
  }

  openModal(modal, modalSize): void {
    this.modalReference = this.modalService.open(modal, { size: modalSize });
  }

  closeModal(): void {
    if (this.modalReference) {
      this.modalReference.close();
    }
  }

  showAlert(msgType, msg): void {
    this.alertSubscription = this._alert.subscribe(
      message => (msgType ? (this.successMessage = message) : (this.errorMessage = message))
    );
    debounceTime
      .call(this._alert, 3000)
      .subscribe(() => (msgType ? (this.successMessage = undefined) : (this.errorMessage = undefined)));
    this._alert.next(msg);
    this.alertSubscription.unsubscribe();
  }

  isNumber(event: any): boolean {
    const charCode = event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }

    return true;
  }

  isLetter(event: any): boolean {
    const letters = /^[A-Za-z]+$/;
    const charKey = event.key;
    if (!charKey.match(letters)) {
      return false;
    }

    return true;
  }

  isEmail(email: string): void {
    this.validEmail = EmailValidator.validate(email);
  }
}



// WEBPACK FOOTER //
// ./src/app/community-management/community-resources/community-manager/community-manager.component.ts